import {fetchDataFromApi} from './apiHelper';

export const fetchLogsStatisticsData = () => fetchDataFromApi('post', '/api/logs/fields');